import { analyticEvent, inlineErrorEvent, onLoadErrorEvent, overlayEvent } from './common';

const unsubEmailText = 'marketing preferences: unsubscribe from all emails button';
export const unsubscribeFromAllEmail = analyticEvent(unsubEmailText);
export const unsubscribeFromAllEmailError = inlineErrorEvent(unsubEmailText);
export const unsubscribeFromAllEmailSuccess = analyticEvent('mktg pref:email list>n');

export const confirmOverlay = overlayEvent('please confirm your unsubscribe request');

export const emailRetrievePageLoadError = onLoadErrorEvent('email preferences');

export const emailUpdateError = inlineErrorEvent('email preferences subscription update');
